import {SectionNotification as SectionNotificationTPA} from '@wix/wix-ui-tpa/cssVars'
import React from 'react'
import {SectionNotificationProps} from './interfaces'

export const SectionNotification = ({text, icon, className, type, size}: SectionNotificationProps) => (
  <SectionNotificationTPA type={type} size={size} className={className}>
    {icon ? <SectionNotificationTPA.Icon icon={icon} /> : null}
    <SectionNotificationTPA.Text>{text}</SectionNotificationTPA.Text>
  </SectionNotificationTPA>
)
